module.exports = __webpack_public_path__ + "aa4ae726fd937779a0a573e6035f5d04.MP3";